import { IPaymentOverview } from '../../architecture/interfaces/HTTP/AdminParams';
import { HttpAgent } from '../../utility/HttpAgent';

export class ContingentConnector {
  static async getOverview(botId: string): Promise<IPaymentOverview> {
    return await HttpAgent.requests.get(`/Api/V2/Bots/${botId}/Contingent`);
  }
}
